import { useEffect } from 'react';
import { useRouter } from '@tanstack/react-router';

/**
 * Calls `onPathChange` once a navigation to a new path resolves. For surfaces that
 * close when the page behind them changes, whatever started the navigation.
 * Pass a stable callback: a new one resubscribes.
 */
export function useOnPathChange(onPathChange: () => void) {
  const router = useRouter();

  // Subscribes to the router's navigation events.
  useEffect(
    () =>
      router.subscribe('onResolved', ({ pathChanged }) => {
        if (pathChanged) {
          onPathChange();
        }
      }),
    [router, onPathChange],
  );
}
